export const GET_EVENT_ATTRIBUTES_LIST_URL: string = 'account/{accountId}/event-attributes/list';
export const CREATE_EVENT_ATTRIBUTE_URL: string = 'account/{accountId}/event-attributes';
export const GET_EVENT_ATTRIBUTE_DETAILS_URL: string = 'account/{accountId}/event-attributes/{eventAttributeId}';